import React, { FunctionComponent } from 'react';
import FlybuysInfoSection from 'scenes/common/components/FlybuysInfo/FlybuysInfoSection';
import QuoteNumberCard from 'scenes/common/components/QuoteInformation/QuoteNumberCards/QuoteNumberCard';
import QuotePriceCard from 'scenes/common/components/QuoteInformation/QuotePriceCards/QuotePriceCard';
import MarketingCampaign from '../MarketingCampaign/MarketingCampaign';
import { SidebarProps } from './types';

export const Sidebar: FunctionComponent<SidebarProps> = ({
  quoteNumber,
  coverType,
  premium: { price, annualPrice, monthlyInstalment },
  showMarketingCampaign,
  showQuotePrice,
  showQuoteNumber,
  showSidebarFlybuysSection,
  selectedPaymentFrequency,
  campaign,
  insuranceName,
  firstInstalment,
  followingMonths,
  awardsToDisplay,
  ClaimCvpComponent,
  isBeforeEffectiveEndDate,
}) => (
  <>
    {showQuotePrice && (
      <QuotePriceCard
        sidebarDisplay
        selectedPaymentFrequency={selectedPaymentFrequency}
        price={price}
        annualPrice={annualPrice}
        coverType={coverType}
        monthlyInstalment={monthlyInstalment}
        firstInstalment={firstInstalment}
        followingMonths={followingMonths}
      />
    )}
    {showQuoteNumber && (
      <QuoteNumberCard
        sidebarDisplay
        quoteNumber={quoteNumber}
        isBeforeEffectiveEndDate={isBeforeEffectiveEndDate}
      />
    )}
    {showMarketingCampaign && (
      <MarketingCampaign quoteNumber={quoteNumber} campaign={campaign} />
    )}
    {showSidebarFlybuysSection && (
      <FlybuysInfoSection insuranceName={insuranceName} />
    )}
    {awardsToDisplay && awardsToDisplay.map((Award) => <Award />)}
    {ClaimCvpComponent}
  </>
);

export default Sidebar;
